import PropTypes from 'prop-types'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useGuards } from '@/hooks/useGuards'
import { useAuth } from '@/hooks/useAuth'
import { authGuard } from '@/guards/authGuard'

export const ProtectedRoute = ({ guards = [authGuard] }) => {
  const location = useLocation()
  const { consultant, loading } = useAuth()
  const redirectPath = useGuards(guards, {
    pathname: location.pathname,
    search: location.search,
    consultant,
  })

  if (loading) return null
  if (redirectPath) return <Navigate to={redirectPath} replace />

  return <Outlet />
}

ProtectedRoute.propTypes = {
  guards: PropTypes.arrayOf(PropTypes.func),
}
